<template>
    <tab-section title="Billing Schedule">
        <data-table
            :id="`project-${record.id}-billing-schedule`"
            :columns="visible_columns"
            :rows="filtered_rows"
            :search="state.search"
            :total="state.total"
            :found="state.found"
            :current-page="state.page"
            :total-pages="nb_pages"
            :searchable="false"
            table-class="lam-table-cell-nowrap lam-subrecords-list"
            empty-title="No billing schedule set... yet!"
            @sort="sort_by"
            @page="goto_page"
        >

            <template
                v-slot:summary="{ row }"
            >
                <h6>{{ row.starts_at_as_string | nibnut.date }}</h6>
            </template>
            <template
                v-slot:tbody="{ row, field }"
            >
                <form-checkbox
                    v-if="field === 'billed_at_as_string'"
                    :id="`billing-schedule-month-${row.id}-billed_at`"
                    :value="!!row.billed_at_as_string"
                    name="billed_at"
                    :error="has_error('billed_at')"
                    @input="save_for_record_id(row.id, $event ? $moment().format('YYYY-MM-DD HH:mm:ss') : null, 'billed_at')"
                />
                <span v-else-if="field === 'starts_at_as_string'">{{ row.starts_at_as_string | nibnut.date("MM-DD-YYYY") }}</span>
                <span v-else-if="field === 'amount'">${{ row.amount | nibnut.number("0,0.00") }}</span>
                <span v-else>{{ row[field] }}</span>
            </template>
        </data-table>
    </tab-section>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import is_project_data_source_tab_section from "../mixins/IsProjectDataSourceTabSection"

import FormCheckbox from "../../../ui/FormCheckbox"

export default {
    mixins: [is_project_data_source_tab_section],
    components: {
        FormCheckbox
    },
    computed: {
        ...mapGetters(["entity_records"]),
        rows () {
            const rows = {}
            this.entity_records(this.entity, this.current_records_ids).forEach(row => {
                const date_index = this.$moment(row.starts_at_as_string || row.starts_at)
                if(!rows[date_index]) rows[date_index] = { ...row }
                else rows[date_index].amount += row.amount
            })
            return Object.values(rows)
        },
        visible_columns () {
            return {
                billed_at_as_string: this.columns.billed_at_as_string,
                starts_at_as_string: this.columns.starts_at_as_string,
                phase_name: this.columns.phase_name,
                amount: this.columns.amount
            }
        }
    },
    data () {
        return {
            entity: "billing_schedule_month",
            columns: {
                billed_at_as_string: { label: "Billed", sort: false, type: "plain", cell_class: "uk-width-1-10" },
                starts_at_as_string: { label: "Due", sort: "asc", type: "plain" },
                phase_name: { label: "Phase", sort: false, type: "plain" },
                amount: { label: "Amount", sort: null, type: "plain", cell_class: "uk-width-3-10" },
                project_id: { label: "Project ID", sort: false, type: "plain" }
            },
            default_state: {
                per_page: 0,
                page: 1,
                sort_by: "starts_at_as_string",
                sort_dir: "asc",
                filter_on: "project_id",
                filter: null,
                archived: false,
                search: "",
                total: 0,
                found: 0,
                query_info: {},
                project_id: 0
            }
        }
    }
}
</script>
